import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../i18n';

/**
 * @summary SiteFooter
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('site-footer')
class SiteFooter extends i18nMixin(AoflElement) {

  /**
   * Creates an instance of SiteFooter.
   */
  constructor() {
    super();
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static get is() {
    return 'site-footer';
  }

  @property({type: Number})
  year = new Date().getFullYear();

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default SiteFooter;
